import { render, staticRenderFns } from "./ProjectsIcon.vue?vue&type=template&id=06691b18"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06691b18')) {
      api.createRecord('06691b18', component.options)
    } else {
      api.reload('06691b18', component.options)
    }
    module.hot.accept("./ProjectsIcon.vue?vue&type=template&id=06691b18", function () {
      api.rerender('06691b18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/ProjectsIcon.vue"
export default component.exports